// Community invite links — paste your real WhatsApp community / Telegram
// channel invite URLs here to activate the "Join the Community" buttons.
export const COMMUNITY = {
  whatsapp: "", // e.g. "https://chat.whatsapp.com/XXXXXXXXXXXX"
  telegram: "", // e.g. "https://t.me/apocalypz"
};

export function shareLinks(url, text) {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(text);
  return {
    whatsapp: `https://wa.me/?text=${t}%20${u}`,
    telegram: `https://t.me/share/url?url=${u}&text=${t}`,
    twitter: `https://twitter.com/intent/tweet?url=${u}&text=${t}`,
  };
}
